// One-time question for a Mao that has no gender yet: "Male or female cat?" It is permanent: it decides who the Mao may marry.
import './invites.css'
import { Events, on } from './eventBus.js'
import { chooseGender } from '../game/genderManager.js'

export function mountGenderPrompt() {
  const layer = document.createElement('div')
  layer.className = 'inv-layer'
  document.body.appendChild(layer)
  let picked = null
  const render = (err = '') => {
    layer.innerHTML = `<div class="inv-pop"><div class="inv-card" role="dialog" aria-modal="true" aria-labelledby="gen-title">
      <div class="inv-kicker">One question</div>
      <h2 id="gen-title">Is your Mao a male or a female cat?</h2>
      <p>This is <b>permanent</b>. It decides who your Mao may marry: a male cat may have up to 5 wives, a female cat only one husband. It is shown on the Registry.</p>
      <div class="inv-actions" role="radiogroup" aria-label="Gender">
        <button type="button" class="inv-btn ${picked === 'MALE' ? 'inv-btn--main' : ''}" role="radio" aria-checked="${picked === 'MALE'}" data-gen="MALE">♂ Male</button>
        <button type="button" class="inv-btn ${picked === 'FEMALE' ? 'inv-btn--main' : ''}" role="radio" aria-checked="${picked === 'FEMALE'}" data-gen="FEMALE">♀ Female</button>
      </div>
      <p class="inv-error" role="alert" ${err ? '' : 'hidden'}>${err}</p>
      <div class="inv-actions"><button type="button" class="inv-btn inv-btn--main" data-gen-ok ${picked ? '' : 'disabled'}>Confirm — forever</button></div>
    </div></div>`
    layer.querySelector('[data-gen]')?.focus()
  }
  layer.addEventListener('click', async (e) => {
    const g = e.target.closest('[data-gen]')?.dataset.gen
    if (g) { picked = g; render(); return }
    if (e.target.closest('[data-gen-ok]') && picked) {
      try { await chooseGender(picked); layer.innerHTML = '' } catch (err) { render(err?.body?.error ?? 'Could not save — try again.') }
    }
  })
  on(Events.NeedGender, () => { picked = null; render() })
}
